import { render, staticRenderFns } from "./KopSurat.vue?vue&type=template&id=8a7df56c&"
import script from "./KopSurat.vue?vue&type=script&lang=js&"
export * from "./KopSurat.vue?vue&type=script&lang=js&"
import style0 from "./KopSurat.vue?vue&type=style&index=0&id=8a7df56c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports